"use client";
import { useTranslations } from "next-intl";

export const LoadingIndicator = () => {
  const t = useTranslations("common");
  return (
    <div
      className="w-full h-fit flex items-center justify-center"
      title={t("loading")}
    >
      <svg
        className="lds-message"
        width="80px"
        height="80px"
        viewBox="0 0 100 100"
        preserveAspectRatio="xMidYMid"
      >
        <g transform="translate(25 50)">
          <circle cx="0" cy="0" r="6" fill="#727272">
            <animateTransform
              attributeName="transform"
              type="scale"
              begin="-0.333s"
              values="0;1;0"
              keyTimes="0;0.5;1"
              dur="1s"
              repeatCount="indefinite"
              calcMode="spline"
              keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
            />
          </circle>
        </g>
        <g transform="translate(50 50)">
          <circle cx="0" cy="0" r="6" fill="#727272">
            <animateTransform
              attributeName="transform"
              type="scale"
              begin="-0.167s"
              values="0;1;0"
              keyTimes="0;0.5;1"
              dur="1s"
              repeatCount="indefinite"
              calcMode="spline"
              keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
            />
          </circle>
        </g>
        <g transform="translate(75 50)">
          <circle cx="0" cy="0" r="6" fill="#727272">
            <animateTransform
              attributeName="transform"
              type="scale"
              begin="0s"
              values="0;1;0"
              keyTimes="0;0.5;1"
              dur="1s"
              repeatCount="indefinite"
              calcMode="spline"
              keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
            />
          </circle>
        </g>
      </svg>
    </div>
  );
};
